class DrawerManager {
    constructor() {
        this.overlay = document.getElementById('drawerOverlay');
        this.activeDrawer = null;
        this.init();
    }

    init() {
        // Handle open drawer buttons
        document.addEventListener('click', (e) => {
            if (e.target.hasAttribute('data-drawer')) {
                const drawerId = e.target.getAttribute('data-drawer');
                this.openDrawer(drawerId);
            }
        });

        // Handle close drawer buttons
        document.addEventListener('click', (e) => {
            if (e.target.hasAttribute('data-close')) {
                const drawerId = e.target.getAttribute('data-close');
                this.closeDrawer(drawerId);
            }
        });

        // Handle overlay click
        this.overlay.addEventListener('click', () => {
            this.closeAllDrawers();
        });

        // Handle ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.activeDrawer) {
                this.closeAllDrawers();
            }
        });
 
    }

    openDrawer(drawerId) {
        // Close any currently open drawer first
        this.closeAllDrawers();

        const drawer = document.getElementById(drawerId);
        if (!drawer) {
            console.error(`Drawer with ID "${drawerId}" not found`);
            return;
        }

        drawer.classList.add('active');
        this.overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.activeDrawer = drawerId;

        // Trigger custom event
        document.dispatchEvent(new CustomEvent('drawerOpened', {
            detail: { drawerId }
        }));
    }

    closeDrawer(drawerId) {
        const drawer = document.getElementById(drawerId);
        if (!drawer) return;

        drawer.classList.remove('active');

        // Check if any other drawers are still active
        const activeDrawers = document.querySelectorAll('.drawer.active');
        if (activeDrawers.length === 0) {
            this.overlay.classList.remove('active');
            document.body.style.overflow = '';
            this.activeDrawer = null;
        }

        // Trigger custom event
        document.dispatchEvent(new CustomEvent('drawerClosed', {
            detail: { drawerId }
        }));
    }

    closeAllDrawers() {
        const activeDrawers = document.querySelectorAll('.drawer.active');
        activeDrawers.forEach(drawer => {
            drawer.classList.remove('active');
        });

        this.overlay.classList.remove('active');
        document.body.style.overflow = '';
        this.activeDrawer = null;

        // Trigger custom event
        document.dispatchEvent(new CustomEvent('allDrawersClosed'));
    }

    // Public methods for programmatic control
    isDrawerOpen(drawerId) {
        const drawer = document.getElementById(drawerId);
        return drawer && drawer.classList.contains('active');
    }

    getActiveDrawer() {
        return this.activeDrawer;
    }
 
}

// Initialize the drawer manager
const drawerManager = new DrawerManager();
 